module.exports = __webpack_public_path__ + "static/media/vision.1c357197.svg";